var name = {};
module['exports'] = name;
name.first_name = require("./first_name");
name.last_name = require("./last_name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_IND/name/index.js
// module id = 1046
// module chunks = 0